import React from "react";

const Glossary = props => (
  <svg viewBox="0 0 16 21" fill="none" {...props}>
    <path
      d="M.833 2.375C.833 1.359 1.653.5 2.708.5h11.25c1.016 0 1.875.86 1.875 1.875v17.188c0 .546-.43.937-.976.937a.897.897 0 01-.547-.156l-5.977-4.219-6.015 4.219a.897.897 0 01-.547.156c-.547 0-.938-.39-.938-.938V2.375z"
      fill="#F12186"
    />
  </svg>
);

export default Glossary;
